import React from 'react';
import { Table, Form, OverlayTrigger, Tooltip, Dropdown, Button } from 'react-bootstrap';

const mockContact = {
    initials: 'JD',
    name: 'John Doe',
    role: 'Senior Developer',
    email: 'john.doe@example.com',
    phone: '+1 234 567 8900',
    department: 'Development',
    skills: ['React', 'Node.js', 'JavaScript']
};

const ClientTable = ({
    onEdit,
    onViewHistory,
    onView,
    onDelete,
    onContactClick
}) => {
    const [expandedRows, setExpandedRows] = React.useState(new Set());

    const toggleRow = (index) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(index)) {
            newExpandedRows.delete(index);
        } else {
            newExpandedRows.add(index);
        }
        setExpandedRows(newExpandedRows);
    };

    const renderAvatar = (text, tooltip) => (
        <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
            <div 
                className='c-avatar c-avatar-text c-avatar-sm me-0'
                onClick={() => onContactClick(mockContact)}
                style={{ cursor: 'pointer' }}
            >
                {text}
            </div>
        </OverlayTrigger>
    );

    return (
        <Table responsive className='c-table'>
            <thead>
                <tr>
                    <th>Client Name</th>
                    {/* <th width="200px" className='text-center'>Task Completion</th> */}
                    <th width="100px" className='text-center'>Email</th>
                    <th width="100px" className='text-center'>Phone</th>
                    <th width="200px" className='text-center'>Budget</th>
                    <th width="200px" className='text-center'>Timeline Progress</th>
                    <th width="80px" className='text-center'>Status</th>
                    <th width="80px" className='text-center'>Actions</th>
                </tr>
            </thead>
            <tbody>
                {[...Array(10)].map((_, i) => (
                    <React.Fragment key={i}>
                        <tr>
                            <td>
                                <div className='d-flex align-items-center'>
                                    <Button variant="link" className='me-3' onClick={() => toggleRow(i)}>
                                        <i className={`fas fa-chevron-${expandedRows.has(i) ? 'down' : 'right'}`}></i>
                                    </Button>
                                    <div className='d-flex align-items-center'>
                                        <div className='c-avatar c-avatar-text'>
                                            N
                                        </div>
                                        <div>
                                            <div className='p-tag fw-bold'>Netclues Technologies</div>
                                            <div className='p-tag fs-12'>123 Business Street, Tech City, TC 12345</div>
                                            <div className='p-tag fs-12'>5 projects</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            {/* <td>
                                <div className="d-flex flex-column align-items-start">
                                    <div className="p-tag fw-bold fs-12 mb-1">53%</div>
                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                        <div>250/118 tasks left</div>
                                    </div>
                                </div>
                            </td> */}
                            <td>
                                <div className='d-flex align-items-center justify-content-center'>
                                    {renderAvatar('JD', 'John Doe')}
                                </div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center justify-content-center'>
                                    {renderAvatar('JD', 'John Doe')}
                                </div>
                            </td>
                            <td>
                                {/* <div className="d-flex flex-column align-items-start">
                                    <div className="p-tag fw-bold fs-12 mb-1">$24k (10%)</div>
                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                        <div>$250k total</div>
                                    </div>
                                </div> */}
                            </td>
                            <td>
                                <div className="d-flex flex-column align-items-start">
                                    <div className="p-tag fw-bold fs-12 mb-1">239h 0m (40%)</div>
                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                        <div>600h total</div>
                                    </div>
                                </div>
                            </td>
                            <td className='text-center'>
                                <div className='c-form-switch'>
                                    <Form.Check
                                        type="switch"
                                        id="custom-switch-01"
                                        label=""
                                        onClick={onDelete}
                                    />
                                </div>
                            </td>
                            <td className='text-center'>
                                <Dropdown className='c-dropdown-1'>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                        <i className="fas fa-ellipsis-v"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={onEdit}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                        <Dropdown.Item><i className="fas fa-eye me-2"></i> View</Dropdown.Item>
                                        <Dropdown.Item onClick={onViewHistory}><i className="fas fa-history me-2"></i> View History</Dropdown.Item>
                                        <Dropdown.Item onClick={onDelete} className="text-danger"><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                        {expandedRows.has(i) && (
                            <>
                                {[...Array(3)].map((_, i) => (
                                    <React.Fragment key={i}>
                                        <tr className='sub-row'>
                                            <td>
                                                <div className='p-tag fw-bold'>E-commerce Platform Development</div>
                                                <div className='p-tag fs-12'>PM: John Smith | Sales: Kartik Mehta</div>
                                                <div className='p-tag fs-12'>Date: 01/01/2023 to 01/31/2023</div>
                                            </td>
                                            {/* <td>
                                                <div className="d-flex flex-column align-items-start">
                                                    <div className="p-tag fw-bold fs-12 mb-1">53%</div>
                                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                                        <div>50/24 tasks left</div>
                                                    </div>
                                                </div>
                                            </td> */}
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    {renderAvatar('JD', 'John Doe')}
                                                    {renderAvatar('JD', 'John Doe')}
                                                    {renderAvatar('+3', '+3 Members')}
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    {renderAvatar('JD', 'John Doe')}
                                                    {renderAvatar('JD', 'John Doe')}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column align-items-start">
                                                    <div className="p-tag fw-bold fs-12 mb-1">$5k (9%)</div>
                                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                                        <div>$50k total</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column align-items-start">
                                                    <div className="p-tag fw-bold fs-12 mb-1">89h 0m (74%)</div>
                                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                                        <div>120h total</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown className='c-dropdown-2'>
                                                    <Dropdown.Toggle variant="btn" id="dropdown-basic">
                                                        No Status
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <button onClick={onDelete} className="dropdown-item">No Status</button>
                                                        <button onClick={onDelete} className="dropdown-item">New Project</button>
                                                        <button onClick={onDelete} className="dropdown-item">In Discussion</button>
                                                        <button onClick={onDelete} className="dropdown-item">Cancelled</button>
                                                        <button onClick={onDelete} className="dropdown-item">Layout in Process</button>
                                                        <button onClick={onDelete} className="dropdown-item">Layout Submitted</button>
                                                        <button onClick={onDelete} className="dropdown-item">Layout Approved</button>
                                                        <button onClick={onDelete} className="dropdown-item">Awaiting Dev. Team</button>
                                                        <button onClick={onDelete} className="dropdown-item">In Progress</button>
                                                        <button onClick={onDelete} className="dropdown-item">Project Delayed</button>
                                                        <button onClick={onDelete} className="dropdown-item">on Hold</button>
                                                        <button onClick={onDelete} className="dropdown-item">Completed</button>
                                                        <button onClick={onDelete} className="dropdown-item">Go Live</button>
                                                        <button onClick={onDelete} className="dropdown-item">Termination</button>
                                                        <button onClick={onDelete} className="dropdown-item">Bad Debt</button>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown className='c-dropdown-1'>
                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                        <i className="fas fa-ellipsis-v"></i>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={onEdit}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                                        <Dropdown.Item><i className="fas fa-eye me-2"></i> View</Dropdown.Item>
                                                        <Dropdown.Item onClick={onViewHistory}><i className="fas fa-history me-2"></i> View History</Dropdown.Item>
                                                        <Dropdown.Item onClick={onDelete} className="text-danger"><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
};

export default ClientTable;